var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0608 10.8844C15.4653 10.8844 17.4145 8.93513 17.4145 6.53062C17.4145 4.12612 15.4653 2.17688 13.0608 2.17688C10.6563 2.17688 8.70703 4.12612 8.70703 6.53062C8.70703 8.93513 10.6563 10.8844 13.0608 10.8844Z",
    fill: "#FFDF80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0609 22.8571C17.2688 22.8571 20.68 20.9079 20.68 18.5034C20.68 16.0989 17.2688 14.1497 13.0609 14.1497C8.85306 14.1497 5.44189 16.0989 5.44189 18.5034C5.44189 20.9079 8.85306 22.8571 13.0609 22.8571Z",
    fill: "#FFDF80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.94f883d59b004d01de13349703e1fa70.svg";
export { ForwardRef as ReactComponent };